import { clearSessionActiveOrgId } from '@/lib/utils/activeOrganisation';
import { signOut } from 'next-auth/react';

type HandleSignOutOptions = {
  callbackUrl?: string;
};

let signOutInFlight: Promise<void> | null = null;

const getCallbackUrl = (value: HandleSignOutOptions | unknown): string => {
  if (value != null && typeof value === 'object' && 'callbackUrl' in value) {
    const callbackUrl = value.callbackUrl;

    if (typeof callbackUrl === 'string' && callbackUrl.length > 0) {
      if (typeof window !== 'undefined') {
        return new URL(callbackUrl, window.location.origin).toString();
      }

      return callbackUrl;
    }
  }

  if (typeof window !== 'undefined') {
    return window.location.origin;
  }

  return '/';
};

export const handleSignOut = async (options?: HandleSignOutOptions) => {
  const callbackUrl = getCallbackUrl(options);

  if (signOutInFlight != null) {
    return signOutInFlight;
  }

  clearSessionActiveOrgId();

  signOutInFlight = (async () => {
    const fallbackCallbackUrl = callbackUrl;

    try {
      await signOut({ callbackUrl, redirect: false });

      if (typeof window !== 'undefined') {
        window.location.replace(fallbackCallbackUrl);
      }
    } catch (error) {
      console.error('Sign out failed:', error);

      if (typeof window !== 'undefined') {
        window.location.replace(fallbackCallbackUrl);
      }
    } finally {
      signOutInFlight = null;
    }
  })();

  try {
    await signOutInFlight;
  } finally {
    signOutInFlight = null;
  }
};
